<script>
    import './assets/css/bootstrap.min.css';
    import Step1 from './pages/Step1.svelte';

    export let step = 1;
    export let stepComponent = Step1;
</script>

<main>
    <div class="popup-calculator">
        <div class="close-bt"><i class="icon-cust-close-01"></i></div>
        <p>Datele pe care le introduci în aceste calculatoare sunt în siguranță și confidențiale, nu ajung la noi și nu se înregistrează.</p>
    </div>
    
    <section class="pb-4">
        <div class="container">
            <div class="progress-bar-container">
                <div class="banometru-progress step-{step}"></div>
                <div class="progres-bulina">
                    <div>Pasul</div>
                    <div class="circle">
                        {step}
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-calculator-banometru">
        <div class="container big-container">
            <svelte:component this={stepComponent} bind:step={step} bind:stepComponent={stepComponent}/>
        </div>
    </section>

    <div class="page-bg bg-grey-light"></div>
</main>
